import { DEFAULT_PAGE_SIZE, Sort } from '@/store/fundraising-search.store';
import {
  LocationQueryRaw,
  RouteLocationNormalizedLoaded,
  Router,
} from 'vue-router';
import {
  getSearchKeyword,
  getSearchPage,
  getSearchPageSize,
  getSearchSort,
  setSearchKeyword,
  setSearchPage,
  setSearchPageSize,
  setSearchSort,
} from './search-results.service';

interface SearchRouterParams extends LocationQueryRaw {
  keyword: string;
  sort: string;
  page: number;
  pagesize: number;
}

const getKeyForStringEnum = (value: string): string | undefined => {
  return Object.entries(Sort).find(([, val]) => val === value)?.[0];
};

export const syncQueryParamsToStore = (
  route: RouteLocationNormalizedLoaded
): void => {
  const keyword = getSearchKeyword();
  if (route.query.keyword && route.query.keyword !== keyword) {
    setSearchKeyword(String(route.query.keyword));
  }

  const sort = getSearchSort();
  if (route.query.sort && route.query.sort !== sort) {
    const key = getKeyForStringEnum(String(route.query.sort));
    if (key) {
      setSearchSort(Sort[key as keyof typeof Sort]);
    }
  }

  const page = getSearchPage();
  if (route.query.page && Number(route.query.page) !== page) {
    setSearchPage(Number(route.query.page));
  }

  const pagesize = getSearchPageSize();
  if (route.query.pagesize && Number(route.query.pagesize) !== pagesize) {
    setSearchPageSize(Number(route.query.pagesize));
  }
};

export const syncStoreToQueryParams = (router: Router): void => {
  const query = {} as SearchRouterParams;

  const keyword = getSearchKeyword();
  if (keyword) {
    query.keyword = keyword;
  }

  const sort = getSearchSort();
  if (sort) {
    query.sort = sort;
  }

  const page = getSearchPage();
  if (page) {
    query.page = page;
  }

  const pagesize = getSearchPageSize();
  if (pagesize && pagesize !== DEFAULT_PAGE_SIZE) {
    query.pagesize = pagesize;
  }

  router.replace({ query });
};
